import { configureStore } from "./store_config";
export const store = configureStore();